// src/pages/admin/candidate-status/constants.js

export const CANDIDATE_STATUS_TYPE_META = {
  INITIAL: {
    label: "Initial",
    className:
      "border border-blue-500/20 bg-blue-500/10 text-blue-600 dark:bg-blue-500/15 dark:text-blue-300",
  },
  HIRED: {
    label: "Hired",
    className:
      "border border-success/20 bg-success/10 text-success",
  },
  REJECTED: {
    label: "Rejected",
    className:
      "border border-error/20 bg-error/10 text-error",
  },
  // Same bordered-pill shape the other types wear — the view modal used to
  // draw Reusable (and every type) without an outline, so switching themes
  // changed how much of the badge was visible.
  REUSABLE: {
    label: "Reusable",
    className:
      "border border-purple-500/20 bg-purple-500/10 text-purple-600 dark:bg-purple-500/15 dark:text-purple-300",
  },
  INTERMEDIATE: {
    label: "Intermediate",
    className:
      // `bg-background-tertiary`, not `bg-background-form`: on the table's
      // white light-theme cells the form fill was indistinguishable and the
      // faint border token vanished with it, so the pill read as bare text
      // in light mode while every other type kept its shape in dark.
      "border border-border-primary bg-background-tertiary text-text-secondary",
  },
};

export const getCandidateStatusTypeMeta = (type) =>
  CANDIDATE_STATUS_TYPE_META?.[type] ??
  CANDIDATE_STATUS_TYPE_META.INTERMEDIATE;

export const CANDIDATE_STATUS_DEFAULT_SORT = {
  key: "sequence",
  order: "asc",
};

export const CANDIDATE_STATUS_MODAL_MODES = {
  ADD: "add",
  EDIT: "edit",
  VIEW: "view",
  DELETE: "delete",
};

export const CANDIDATE_STATUS_TABLE_SEARCH_PLACEHOLDER =
  "Search by name, description...";

export const DEFAULT_CANDIDATE_STATUS_FORM_VALUES = {
  name: "",
  description: "",
  sequence: null,
  insertBeforeId: null,
  isInitial: false,
  isHired: false,
  isRejected: false,
  isReusable: false,
  isInterviewEligible: false,
  allowedTransitionIds: [],
};

export const FLOW_MODAL_MODES = {
  ADD: "add",
  EDIT: "edit",
  DELETE: "delete",
};

export const DEFAULT_FLOW_FORM_VALUES = {
  name: "",
  description: "",
  isActive: true,
};
